import { render, staticRenderFns } from "./declare-bak.vue?vue&type=template&id=21633b54&scoped=true"
import script from "./declare-bak.vue?vue&type=script&lang=js"
export * from "./declare-bak.vue?vue&type=script&lang=js"
import style0 from "./declare-bak.vue?vue&type=style&index=0&id=21633b54&prod&scoped=true&lang=scss"
import style1 from "./declare-bak.vue?vue&type=style&index=1&id=21633b54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21633b54",
  null
  
)

export default component.exports